import React from "react"
import { DivCheckbox } from "./styles"

interface Props {
    name: string
    value: boolean
    onClick: (key: string, value: boolean) => void
    placeholder?: string
    label?: string
    readOnly?: boolean
    onChange?: any
    link?: string
    linkText?: string
    error?: boolean
}

const Checkbox: React.FC<Props> = (Props) => {

    const handleCheckbox = () => {
        if (!Props.readOnly) {

            let value = Props.value
            if (value) {
                Props.onClick(Props.name, false)
            } else {
                Props.onClick(Props.name, true)
            }

        }
    }

    return (
        <DivCheckbox className="divCheckbox">
            <div className="text-container">
                {Props.label && <span className="label">{Props.label}</span>}
                {Props.link && (
                    <a href={Props.link} target="_blank" rel="noopener noreferrer" className="link">
                        {Props.linkText || Props.link}
                    </a>
                )}
            </div>

            <div className={`checkbox ${Props.value && "active"} ${Props.error && !Props.value ? "error" : ""}`} onClick={handleCheckbox}>
                <span className="square"></span>
                {Props.placeholder && <span className="text">{Props.placeholder}</span>}
            </div>
        </DivCheckbox>
    )

}

export default Checkbox